import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerCategories = categories.slice(0, 4);
const footerGuides = [
  { label: 'Poradnik Podstawowy', url: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik' },
  { label: 'Porównanie Arkuszy', url: 'https://kaspreadsheet.com', external: true },
  { label: 'Bezpieczne Zakupy', url: 'https://kaspreadsheet.com', external: true },
];
const footerTools = [
  { label: 'Kategorie Produktów', url: 'https://kaspreadsheet.com', external: true },
  { label: 'Nowości', url: 'https://kaspreadsheet.com', external: true },
  { label: 'Popularne', url: 'https://kaspreadsheet.com', external: true },
];
const footerCompany = [
  { label: 'O Nas', url: 'https://kaspreadsheet.com', external: true },
  { label: 'Kontakt', url: 'https://kaspreadsheet.com', external: true },
  { label: 'Polityka Prywatności', url: 'https://kaspreadsheet.com', external: true },
];

export default function Footer() {
  return (
    <footer className="bg-[#1a3a32] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
        <svg viewBox="0 0 1200 600" className="w-full h-full" preserveAspectRatio="none">
          <path
            d="M0,300 Q100,250 200,280 T400,260 T600,290 T800,250 T1000,270 T1200,240"
            fill="none"
            stroke="white"
            strokeWidth="1"
          />
          <path
            d="M0,350 Q150,300 300,330 T600,310 T900,340 T1200,290"
            fill="none"
            stroke="white"
            strokeWidth="0.5"
          />
          <path
            d="M0,400 Q200,360 400,380 T800,360 T1200,370"
            fill="none"
            stroke="white"
            strokeWidth="0.5"
          />
          <circle cx="280" cy="200" r="2" fill="white" />
          <circle cx="550" cy="140" r="1.5" fill="white" />
          <circle cx="780" cy="180" r="2" fill="white" />
          <circle cx="950" cy="120" r="1.5" fill="white" />
          <circle cx="150" cy="250" r="1.5" fill="white" />
          <circle cx="650" cy="220" r="1" fill="white" />
          <circle cx="1050" cy="200" r="2" fill="white" />
          <circle cx="420" cy="160" r="1" fill="white" />
          <circle cx="850" cy="240" r="1.5" fill="white" />
          <circle cx="320" cy="300" r="1" fill="white" />
          <circle cx="700" cy="280" r="1.5" fill="white" />
          <circle cx="1020" cy="260" r="1" fill="white" />
        </svg>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:max-w-[320px]">
            <div className="font-heading text-2xl font-bold text-white">
              KakobuySpreadsheet<span className="text-accent-400">.</span>cc
            </div>
            <p className="mt-4 text-white/50 text-sm leading-relaxed">
              Twój kompletny arkusz zakupowy. Przeglądaj, porównuj i kupuj bezpiecznie — wszystko w jednym miejscu.
            </p>
            <div className="mt-6 flex items-center gap-2">
              <input
                type="email"
                placeholder="Twój adres email"
                className="bg-white/10 border border-white/15 rounded-full px-4 py-2.5 text-sm text-white placeholder:text-white/35 outline-none focus:border-accent-400/50 transition-colors w-full max-w-[220px]"
              />
              <button
                type="button"
                className="w-10 h-10 rounded-full bg-accent-500 text-white flex items-center justify-center cursor-pointer hover:bg-accent-600 transition-colors shrink-0"
              >
                <i className="ri-notification-3-line"></i>
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 flex-1">
            <div>
              <h4 className="font-label font-bold text-white text-sm mb-4">Kategorie</h4>
              <ul className="space-y-2.5">
                {footerCategories.map((cat) => (
                  <li key={cat.id}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer"
                    >
                      {cat.namePl}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-label font-bold text-white text-sm mb-4">Poradniki</h4>
              <ul className="space-y-2.5">
                {footerGuides.map((item, i) => (
                  <li key={i}>
                    {item.external ? (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        to={item.url}
                        className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-label font-bold text-white text-sm mb-4">Narzędzia</h4>
              <ul className="space-y-2.5">
                {footerTools.map((item, i) => (
                  <li key={i}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-label font-bold text-white text-sm mb-4">Firma</h4>
              <ul className="space-y-2.5">
                {footerCompany.map((item, i) => (
                  <li key={i}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/35 text-xs">
            &copy; {new Date().getFullYear()} KakobuySpreadsheet.cc — Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-3">
            {[
              { icon: 'ri-facebook-line', url: 'https://kaspreadsheet.com' },
              { icon: 'ri-twitter-x-line', url: 'https://kaspreadsheet.com' },
              { icon: 'ri-instagram-line', url: 'https://kaspreadsheet.com' },
              { icon: 'ri-linkedin-line', url: 'https://kaspreadsheet.com' },
            ].map((social, i) => (
              <a
                key={i}
                href={social.url}
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 rounded-md border border-white/15 flex items-center justify-center text-white/40 hover:text-white hover:border-white/30 transition-all cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${social.icon} text-sm`}></i>
                </span>
              </a>
            ))}
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-white/35 text-xs hover:text-white/60 transition-colors cursor-pointer"
          >
            Polityka Prywatności
          </a>
        </div>
      </div>
    </footer>
  );
}